import React from 'react'
import { ListViewHeader } from '@progress/kendo-react-listview'
import { Tooltip } from '@progress/kendo-react-tooltip'

const ContractBulletHeaderPure = (props) => {
  return (
    <ListViewHeader className='contract-title'>
      <Tooltip anchorElement='target' position='top' style={{ backgroundColor: 'black', paddingBottom: '15px' }}>
        {/* <a className='white' rel="noopener noreferrer" href='https://www.google.com' target='_blank' title={t('contractBulletHeaderPure.clickLink')} >{t('contractBulletHeaderPure.titletermsConditions')} </a> */}
      </Tooltip> &nbsp;
    </ListViewHeader>
  )
}
{/* </Tooltip> &nbsp;  {t ('contractBulletHeaderPure.principalElements')} */ }

export { ContractBulletHeaderPure as default }
